module.exports = __webpack_public_path__ + "assets/img/3.a7da9751.png";